"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineageIconButton = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const LineageCartoucheStyles_1 = require("../style/LineageCartoucheStyles");
const HoverComponent_1 = require("../widgets/HoverComponent");
const LineageItemType_1 = require("./LineageItemType");
// Renders a clickable link icon for the Lineage Nav
class LineageIconButton extends react_1.default.Component {
    render() {
        const iconClasses = this.props.isCurrentPane
            ? (0, data_catalog_shared_1.classes)(LineageCartoucheStyles_1.cartoucheIconStyle, LineageCartoucheStyles_1.activeLineageItemType)
            : LineageCartoucheStyles_1.cartoucheIconStyle;
        const NormalIcon = (0, LineageItemType_1.getIconForContentType)(this.props.lineageItemType, this.props.isCurrentPane ? LineageItemType_1.IconType.white : LineageItemType_1.IconType.inactive);
        const HoverIcon = (0, LineageItemType_1.getIconForContentType)(this.props.lineageItemType, this.props.isCurrentPane ? LineageItemType_1.IconType.white : LineageItemType_1.IconType.active);
        return (react_1.default.createElement(react_router_dom_1.Link, { to: this.props.linkHref, className: this.props.inCartouche ? LineageCartoucheStyles_1.cartoucheIconButtonClass : LineageCartoucheStyles_1.lineageIconButtonClass },
            react_1.default.createElement(HoverComponent_1.HoverComponent, { normalElement: react_1.default.createElement(NormalIcon, { className: iconClasses }), hoverElement: react_1.default.createElement(HoverIcon, { className: iconClasses }), altText: this.props.buttonAltText })));
    }
}
exports.LineageIconButton = LineageIconButton;
//# sourceMappingURL=LineageIconButton.js.map